import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const GetInvolved = () => {
  const navigate = useNavigate();
  const handleLogin = () => {
    navigate("/login");
  };
  return (
    <Box id="get-involved" sx={{ my: 5 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Get Involved
      </Typography>
      <Container>
        <Grid container spacing={4} justifyContent="center">
          {/* Material Partners Section */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Material Partners
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Collaborate with us as a material partner and contribute to
                  our mission.
                </Typography>
              </CardContent>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <Button variant="contained" color="primary">
                  Learn More
                </Button>
              </Box>
            </Card>
          </Grid>

          {/* Depts & Members Section */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Depts & Members
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Join our departments and become an active member of our
                  community.
                </Typography>
              </CardContent>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleLogin}
                >
                  Join Now
                </Button>
              </Box>
            </Card>
          </Grid>

          {/* Youth Forum Members Section */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Youth Forum Members
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Be part of the youth forum and make a difference in your
                  community.
                </Typography>
              </CardContent>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleLogin}
                >
                  Get Started
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default GetInvolved;
